module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "imger"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "registerForm",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.registerForm,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("注册帐号")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-dianhua"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.registerForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "phone", $$v)
      },
      expression: "registerForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "smsCode"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-securityCode-b"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone form-control",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.registerForm.smsCode),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "smsCode", $$v)
      },
      expression: "registerForm.smsCode"
    }
  }), _vm._v(" "), (_vm.disabled == false) ? _c('el-button', {
    staticClass: "el_reg",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [_vm._v("发送验证码\r\n          ")]) : _vm._e(), _vm._v(" "), (_vm.disabled == true) ? _c('el-button', {
    staticClass: "el_reg",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [_vm._v(_vm._s(_vm.btntxt) + "\r\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-mima"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.registerForm.password),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "password", $$v)
      },
      expression: "registerForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "conpassword"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-querenmima"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "确认密码"
    },
    model: {
      value: (_vm.registerForm.conpassword),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "conpassword", $$v)
      },
      expression: "registerForm.conpassword"
    }
  })], 1), _vm._v(" "), _c('slide-verify', {
    attrs: {
      "slider-text": _vm.texts
    },
    on: {
      "success": _vm.onSuccess,
      "fail": _vm.onFail,
      "refresh": _vm.onRefresh
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("注册")])], 1)], 1)], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBar"
  }, [_c('h1'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.jsdnn.com/",
      "target": "_blank"
    }
  }, [_vm._v("狄诺尼官网")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftBox"
  }, [_c('p', [_vm._v("江苏狄诺尼信息技术有限责任公司")]), _vm._v(" "), _c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-327f89bd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Register.vue
// module id = 1729
// module chunks = 9